export const toggleDropdown = (event: Event) => {
    const $el = event.target! as HTMLElement;
    $el.classList.contains("show") ? $el.classList.remove("show") : $el.classList.add("show");
};
